<template>
  <div class="copy-calendars text-dark"
       v-on-clickaway="closeDropdown">
    <button ref="copy_calendars_button" class="do-bttn" @click.stop="openDropdown">
      <slot name="copy-button-title">{{ $t('vue2.copycalendar.copy') }}</slot>
      <span class="icon-arrow-down5 marg-5-left"></span>
    </button>
    <div ref="copy_calendars_panel" class="copy-calendars__ref" v-if="isDropdown">
      <transition name="fadeInDown">
        <div class="copy-calendars__panel" v-if="isDropdownPopperDone">
          <h3 :style="{'backgroundColor': '#468ad7'}">
            <span v-if="!copyDate">{{ $t('vue2.calendars.select_week_to_copy_from') }}</span>
            <span v-else>{{ $t('vue2.calendars.select_weeks_that_week') }} {{
                showWeek(copyDate)
              }} {{ $t('vue2.calendars.must_be_copied_to') }}</span>
          </h3>
          <div class="copy-calendars__panel__container">
            <div class="weeks-container">
              <ul class="weeks">
                <template v-if="weeks.length < 1">
                  <Spinner color="blue" style="margin-bottom: 100px"></Spinner>
                </template>
                <template v-else>
                  <li class="weeks__week hint--top"
                      v-for="week in weeks"
                      :key="week.serverDate"
                      :aria-label="tooltipDate(week.date)"
                      :class="[{'weeks__week--is-selected': isWeekSelected(week)},{'weeks__week--is-copy-week': isCopyWeek(week)}]"
                      @click="setSelectedWeek(week)">
                    {{ showWeek(week.date) }}
                    <span class="weeks__week__now-indicator" v-if="isNow(week)"></span>
                  </li>
                </template>
              </ul>
            </div>
            <div class="copy-calendars__panel__sidebar">
              <transition name="slide-fade" mode="out-in">
                <div v-if="!copyDate" class="text-explainer" key="1">
                  {{ $t('vue2.calendars.select_week_to_copy_from') }}
                </div>
                <div v-else key="2">
                  <h4>
                    {{ $t('vue2.copycalendar.markWeeksFrom') }} {{ showWeek(copyDate) }}</h4>
                  <button class="bttn width-100 btn-trans" @click="addAllWeeksOnward">
                    {{ $t('vue2.copycalendar.allWeeks') }}
                  </button>
                  <button class="bttn width-100 btn-trans" @click="selectOddWeeks">
                    {{ $t('vue2.copycalendar.oddWeeks') }}
                  </button>
                  <button class="bttn width-100 btn-trans" @click="selectEvenWeeks">
                    {{ $t('vue2.copycalendar.evenWeeks') }}
                  </button>
                  <button class="bttn btn-trans width-100 btn-remove" @click="removeAllSelectedWeeks">
                    {{ $t('vue2.copycalendar.unselectAll') }}
                  </button>
                </div>
              </transition>
            </div>
          </div>
          <div class="copy-calendars__panel__footer">
            <div class="delete-option">
              <label for="checkbox">
                <span>{{ $t('vue2.copycalendar.deleteLessonsInSelectedWeeks') }}</span>
                <span v-if="calType === 'user'"> ({{ $t('vue2.copycalendar.absenceWillNotBeDeleted') }})</span>
              </label>
              <input type="checkbox" id="checkbox" v-model="isDeleteEvents"/>
            </div>
            <button class="bttn bttn--disabled" v-if="selectedWeeks.length < 1">{{
                $t('vue2.copycalendar.paste')
              }}
            </button>
            <button class="do-bttn" @click="submit" v-else>{{ $t('vue2.copycalendar.paste') }}</button>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import {mixin as clickaway} from 'vue-clickaway'
import moment from 'moment'
import {createPopper} from '@popperjs/core'
import Spinner from '../common/Spinner'

export default {
  components: {Spinner},
  mixins: [clickaway],
  props: {
    calType: {
      type: String,
      default: 'klass'
    },
    initCopyDate: {
      default: null
    }
  },
  data () {
    return {
      copyDate: null,
      calStartDate: null,
      calEndDate: null,
      selectedWeeks: [],
      isDropdown: false,
      isDropdownPopperDone: false,
      isDeleteEvents: true
    }
  },
  computed: {
    activeSchoolYears () {
      return this.$store.state.activeSchoolYears
    },
    localActivatedSchoolYear () {
      return this.$store.state.localActivatedSchoolYear
    },
    firstDayOfTheWeek () {
      // 1 == monday
      let start = 1
      if (typeof window.SCHOOL && window.SCHOOL.first_day_of_week_num !== 'undefined') {
        start = window.SCHOOL.first_day_of_week_num
      }
      return start
    },
    weeks () {
      let activeSchoolYear = this.localActivatedSchoolYear
      if (this.calType === 'klass') {
        this.calStartDate = activeSchoolYear.student_time_start
        this.calEndDate = activeSchoolYear.student_time_end
      } else {
        this.calStartDate = activeSchoolYear.employee_time_start
        this.calEndDate = activeSchoolYear.employee_time_end
      }
      const start = moment(this.calStartDate).day(this.firstDayOfTheWeek)
      const end = moment(this.calEndDate).endOf('isoweek')
      let startWeek = moment(start).isoWeek()
      let diff = moment(end).diff(start, 'week')
      let max = startWeek + diff
      let weeks = []
      for (let i = startWeek; i <= max; i++) {
        let date = moment(start).isoWeek(i).day(this.firstDayOfTheWeek)
        weeks.push({
          date: date,
          serverDate: moment(date).format('YYYY-MM-DD'),
          weekNum: date.isoWeek()
        })
      }
      return weeks
    }
  },
  methods: {
    createPopper () {
      let el = this.$refs.copy_calendars_button
      // let el = document.querySelector('#vue-popper__copy_cals_button')
      createPopper(el, this.$refs.copy_calendars_panel, {
        placement: 'bottom-start',
        modifiers: [
          {
            name: 'offset',
            options: {
              offset: ({placement, reference, popper}) => {
                return [0, 5]
              }
            }
          }
        ]
      })
    },
    openDropdown () {
      if (this.initCopyDate) {
        this.copyDate = this.initCopyDate
      }
      this.isDropdown = true
      this.$emit('open')
      setTimeout(_ => {
        this.createPopper()
        this.isDropdownPopperDone = true
      }, 0)
    },
    closeDropdown () {
      if (!this.isDropdown) {
        return
      }
      this.isDropdown = false
      this.$emit('close')
      this.isDropdownPopperDone = false
      this.selectedWeeks = []
      this.calStartDate = null
      this.copyDate = null
    },
    tooltipDate (date) {
      let start = moment(date)
      let start2 = moment(date).format('DD. MMM')
      let startFormat = start.format('DD')
      let end = moment(date).add(6, 'days')
      let endFormat = moment(date).add(6, 'days').format('DD. MMM YYYY')
      // If same month
      if (moment(start).format('MM') === moment(end).format('MM')) {
        return startFormat + ' - ' + endFormat
      } else {
        return start2 + ' - ' + endFormat
      }
    },
    isWeekSelected (week) {
      let idx = this.selectedWeeks.indexOf(week.serverDate)
      return idx > -1
    },
    isCopyWeek (week) {
      return this.copyDate ? moment(week.date).format('GGGG-WW') === moment(this.copyDate).format('GGGG-WW') : false
    },
    isNow (week) {
      return moment(week.date).format('GGGG-WW') === moment().format('GGGG-WW')
    },
    setSelectedWeek (week) {
      // start by selecting copydate
      if (!this.copyDate) {
        this.copyDate = week.date
        return
      }
      if (this.isCopyWeek(week)) {
        this.removeSelectedDate()
        return
      }
      let idx = this.selectedWeeks.indexOf(week.serverDate)
      if (idx < 0) {
        this.selectedWeeks.push(week.serverDate)
      } else {
        this.selectedWeeks.splice(idx, 1)
      }
    },
    removeSelectedDate () {
      this.copyDate = null
      this.selectedWeeks = []
    },
    showWeek (date) {
      return moment(date).isoWeek()
    },
    selectWeek (week) {
      if (this.isCopyWeek(week)) {
        return
      }
      let idx = this.selectedWeeks.indexOf(week.serverDate)
      if (idx < 0) {
        this.selectedWeeks.push(week.serverDate)
      }
    },
    addAllWeeksOnward () {
      if (!this.copyDate) {
        return []
      }
      this.weeks.forEach(week => {
        if (moment(week.date).isSameOrAfter(this.copyDate)) {
          this.selectWeek(week)
        }
      })
    },
    removeAllSelectedWeeks () {
      this.selectedWeeks = []
    },
    selectEvenWeeks () {
      this.weeks.forEach(week => {
        if (moment(week.date).isSameOrAfter(this.copyDate)) {
          if (this.isEven(week.date.isoWeek())) {
            this.selectWeek(week)
          }
        }
      })
    },
    selectOddWeeks () {
      this.weeks.forEach(week => {
        if (moment(week.date).isSameOrAfter(this.copyDate)) {
          if (this.isOdd(week.date.isoWeek())) {
            this.selectWeek(week)
          }
        }
      })
    },
    isEven (n) {
      return /^-?\d*[02468]$/.test(n)
    },
    isOdd (n) {
      return /^-?\d*[13579]$/.test(n)
    },
    submit () {
      let obj = {
        copyDate: this.copyDate,
        selectedWeeks: this.selectedWeeks,
        isDeleteEvents: this.isDeleteEvents
      }
      this.$emit('submit', obj)
      this.closeDropdown()
    }
  }
}
</script>

<style scoped>
@import "../../assets/css/variables.css";

.copy-calendars__ref {
  width: 600px;
  position: absolute;
  z-index: 12;
  text-transform: none;
}

.copy-calendars__panel {
  background: #ffffff;
  border-radius: 4px;
  min-width: 240px;
  max-width: 600px;
  overflow: hidden;
  box-shadow: 0 3px 8px rgba(0, 0, 0, .24);
  height: auto;
  outline: none;
  text-align: left;
  user-select: none;
}

.copy-calendars__panel h3 {
  padding: 2rem 1rem;
  background: #e74c3c;
  color: #ffffff;
}

.copy-calendars__panel__container {
  display: flex;
  align-items: stretch;
}

.copy-calendars__panel .weeks {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  min-width: 418px;
  padding: 3px;
  margin-top: 0;
}

.copy-calendars__panel__container .weeks__week {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 10px;
  height: 42px;
  width: 42px;
  margin: 2px;
  cursor: pointer;
  border-radius: 50%;
  border: 1px solid #edf0f5;
  user-select: none;
  transition: all .25s;
}


.weeks__week:hover {
  border-color: var(--blue);
}

.weeks__week:active {
  transform: scale(0.9);
}

.weeks__week--is-selected {
  background-color: #468ad7;
  color: #fff;
}

.copy-calendars__panel__sidebar {
  border-left: 1px solid #e4e4e4;
  box-sizing: border-box;
  background-color: #fafafa;
  overflow: auto;
  padding: 1rem;
  min-width: 160px;
}

.copy-calendars__panel__sidebar button {
  margin-top: 1rem;
  outline: none;
  transition: transform 0.25s;
}

.copy-calendars__panel__sidebar button:active {
  transform: scale(0.95);
}

.weeks__week--is-copy-week {
  background: #3e4450 !important;
  color: #fff !important;
  border: none !important;
}

.copy-event__panel__sidebar .btn-remove {
  color: #fa565a;
}

.copy-calendars__panel__footer {
  padding: 1rem;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  background-color: #fafafa;
  box-shadow: inset 0 1px 0 0 #e6e8eb;
}

.weeks__week__now-indicator {
  z-index: 100;
  background: #468ad7;
  border-radius: 50%;
  display: block;
  height: .5em;
  left: 50%;
  bottom: 5px;
  margin: 0 0 0 -.22em;
  position: absolute;
  width: .5em;
}

.weeks__week--is-selected .weeks__week__now-indicator, .weeks__week--is-copy-week .weeks__week__now-indicator {
  background: #fff;
}

.school-year-selector {
  margin: 10px;
}

.selectedWeek {
  border: 1px solid #ffffff;
  border-radius: 4px;
  padding: 0.5rem;
  margin: 0 0.5rem;
}

.selectedWeek:hover {
  background: #ffffff;
  color: var(--blue);
  cursor: pointer;
}

.slide-fade-enter-active {
  transition: all .3s ease;
}

.slide-fade-leave-active {
  transition: all .2s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}

.slide-fade-enter
  /* .slide-fade-leave-active below version 2.1.8 */
{
  transform: translateX(10px);
  opacity: 0;
}

.slide-fade-leave-to {
  transform: translateX(-10px);
  opacity: 0;
}

.delete-option {
  display: flex;
  align-items: center;
  margin-right: 10px;
  cursor: pointer;
}

.delete-option:hover {
  color: var(--blue);
}

.delete-option label {
  margin-right: 5px;
  cursor: pointer;
}

.btn-remove {
  color: var(--danger);
}

</style>



// WEBPACK FOOTER //
// CopyMultipleCalendarsCopy.vue?8e2ca792